export interface Project {
  id: number;
  title: string;
  description: string;
  image: string;
  category: 'branding' | 'identity' | 'campaign';
  techStack: string[];
  liveUrl: string;
  githubUrl: string;
  featured: boolean;
}

export const projects: Project[] = [
  {
    id: 1,
    title: 'Urban Juice',
    description: 'Complete brand identity and visual design for a modern juice shop. Created logo, packaging, and marketing materials with vibrant 3D bubble aesthetics.',
    image: 'https://images.squarespace-cdn.com/content/v1/65e120f31066f669d1817be5/1730755851419-PP6EIZSN1S9B93ZEP3BV/soap0UJLogoBubble-ezgif.com-crop.gif',
    category: 'branding',
    techStack: ['Branding', 'Logo Design', 'Packaging', '3D Design'],
    liveUrl: 'https://www.laterbader.com/work/urbanjuice',
    githubUrl: '',
    featured: true,
  },
  {
    id: 2,
    title: 'Tajawul',
    description: 'Brand identity and visual language for a premium golf cart rental service. Designed bilingual Arabic-English logo and cohesive brand system.',
    image: 'https://images.squarespace-cdn.com/content/v1/65e120f31066f669d1817be5/1730759377327-9W04EVO6AIEB4FEOMEHN/Tajawul-cover-laterbader-new.gif',
    category: 'identity',
    techStack: ['Brand Identity', 'Logo Design', 'Arabic Typography', 'Motion'],
    liveUrl: 'https://www.laterbader.com/work/tajawul',
    githubUrl: '',
    featured: true,
  },
  {
    id: 3,
    title: 'Spotify Campaign',
    description: 'Creative campaign work for Spotify featuring dynamic animated visuals and motion graphics for music promotion and engagement.',
    image: 'https://images.squarespace-cdn.com/content/v1/65e120f31066f669d1817be5/1730757487141-UTY9ERFJ3Z8OK94BEJ7I/PERREOANIMATION-ezgif.com-speed.gif',
    category: 'campaign',
    techStack: ['Motion Graphics', 'Animation', 'Campaign Design', 'Art Direction'],
    liveUrl: 'https://www.laterbader.com/work/spotify',
    githubUrl: '',
    featured: true,
  },
  {
    id: 4,
    title: 'Handle',
    description: 'Modern brand identity and animated logo design. Clean, minimal aesthetics with playful motion elements.',
    image: 'https://images.squarespace-cdn.com/content/v1/65e120f31066f669d1817be5/1730760430039-G1T18M02IMRX1HY2PW8J/Handle-logo-animation.gif',
    category: 'identity',
    techStack: ['Logo Animation', 'Brand Identity', 'Motion Design'],
    liveUrl: 'https://www.laterbader.com/work/handle',
    githubUrl: '',
    featured: false,
  },
  {
    id: 5,
    title: 'Salahuddin Softtech Solutions',
    description: 'Complete brand identity for SSS, a technology solutions company. Dynamic logo with spinning animation reflecting innovation and tech forward vision.',
    image: 'https://images.squarespace-cdn.com/content/v1/65e120f31066f669d1817be5/1730899385960-NCS02AIOKUUF2U9M8AFB/SSS+Logo+Spin.gif',
    category: 'branding',
    techStack: ['Corporate Branding', 'Logo Design', 'Motion Graphics', 'Tech Identity'],
    liveUrl: 'https://www.laterbader.com/work/sss',
    githubUrl: '',
    featured: true,
  },
  {
    id: 6,
    title: 'allcaps',
    description: 'Bold typographic brand identity with animated lettering. Created a strong visual presence through custom typography and motion.',
    image: 'https://images.squarespace-cdn.com/content/v1/65e120f31066f669d1817be5/1730901160162-FVCNYIX47P8ZLP0SUHJI/Allacpsanimation-ezgif.com-video-to-gif-converter.gif',
    category: 'identity',
    techStack: ['Typography', 'Logo Animation', 'Brand Identity'],
    liveUrl: 'https://www.laterbader.com/work/allcaps',
    githubUrl: '',
    featured: false,
  },
  {
    id: 7,
    title: 'About Life',
    description: 'Album artwork and visual identity for a music project. Record mockup designs with creative direction and cohesive visual storytelling.',
    image: 'https://images.squarespace-cdn.com/content/v1/65e120f31066f669d1817be5/1730904608378-I4CRCAEWWECD2QXB58XS/Hamachi-Record-Mockup.gif',
    category: 'campaign',
    techStack: ['Album Art', 'Creative Direction', 'Mockup Design', 'Visual Identity'],
    liveUrl: 'https://www.laterbader.com/work/aboutlife',
    githubUrl: '',
    featured: false,
  },
  {
    id: 8,
    title: 'BaderHelp',
    description: 'Personal brand and portfolio identity. Clean, professional design showcasing creative work and services.',
    image: 'https://images.squarespace-cdn.com/content/v1/65e120f31066f669d1817be5/1730905698056-0EQSOZULVOFGJERTK7QK/Bader-Help-animation.gif',
    category: 'branding',
    techStack: ['Personal Branding', 'Logo Design', 'Web Design', 'Portfolio'],
    liveUrl: 'https://www.laterbader.com/work/baderhelp',
    githubUrl: '',
    featured: false,
  },
];
